export default __webpack_public_path__ + "static/img_interviewee_dssong@2x-55472f1f7182e39205c788b7d8aa70b4.png";